"use client"

import { useState } from "react"
import LoginModal from "./LoginModal"
import SignupModal, { SIGNUP_MODAL_ENABLED } from "./SignupModal"

export default function LoginButton({ text, forceModal }: { text: string; forceModal?: boolean }) {
    const [isLoginOpen, setIsLoginOpen] = useState(false)
    const [isSignupOpen, setIsSignupOpen] = useState(false)

    const enabled = forceModal || SIGNUP_MODAL_ENABLED

    if (!enabled) {
        return (
            <a className="font-medium text-sm text-slate-300 hover:text-white whitespace-nowrap transition duration-150 ease-in-out" href="/signin">
                <span className="relative inline-flex items-center">{text}</span>
            </a>
        )
    }

    return (
        <>
            <button onClick={() => setIsLoginOpen(true)} className="font-medium text-sm text-slate-300 hover:text-white whitespace-nowrap transition duration-150 ease-in-out">
                <span className="relative inline-flex items-center">{text}</span>
            </button>
            <LoginModal
                isOpen={isLoginOpen}
                onClose={() => setIsLoginOpen(false)}
                onSwitchToSignup={() => { setIsLoginOpen(false); setIsSignupOpen(true) }}
            />
            <SignupModal isOpen={isSignupOpen} onClose={() => setIsSignupOpen(false)} />
        </>
    )
}
